import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type StatsSpotFields = {
  backgroundColor: Field<string>;
  eyebrowText: Field<string>;
  headline: Field<string>;
  description: Field<string>;
  stats: StatProps[];
  footerText: Field<string>;
  ctaButtonLink: LinkField;
  ctaButtonLabel: Field<string>;
  ctaButtonAriaLabel?: Field<string>;
  disclaimers: DisclaimerProps[];
};

export type StatProps = {
  id?: string;
  value: Field<string>;
  valueFontColor: Field<string>;
  description: Field<string>;
};

export type DisclaimerProps = {
  id?: string;
  text: Field<string>;
};
